import { AiOutlinePartition } from 'react-icons/ai';
import { FaDatabase, FaUserCog } from 'react-icons/fa';
import { GiMachineGun } from 'react-icons/gi';
import { GoTools } from 'react-icons/go';
import { MdDashboard, MdOutlineAccessTime } from 'react-icons/md';
import { TbBuildingWarehouse } from 'react-icons/tb';
import { RenderTiles } from '../../components/common';
import ChildHeader from '../../components/ui/ChildHeader';
import { BsList } from 'react-icons/bs';
import { HiDocumentReport } from 'react-icons/hi';
export type tilesType = {
  sNo: number;
  link: string;
  isLink: boolean;
  isIcon: boolean;
  clauseNo?: string | number;
  p: string;
  span: string;
  icon?: any;
  style?: {};
}[];
const tiles = [
  {
    sNo: 1,
    link: '/admin/masterlistofmachine?filter=createdAt',
    isLink: true,
    clauseNo: 4,
    icon: <AiOutlinePartition size="5rem" color="#135089" />,
    p: 'Master List Of',
    span: 'Machine',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/admin/manMachineMatrixList?filter=createdAt',
    isLink: true,
    clauseNo: 4,
    icon: <FaUserCog size="5rem" color="#135089" />,
    p: 'Man Machine',
    span: 'Matrix',
    isIcon: true,
  },
  {
    sNo: 4,
    link: '/common/defectList',
    isLink: true,
    clauseNo: 4,
    icon: <BsList size="5rem" color="#135089" />,
    p: 'MASTER LIST OF',
    span: 'DOWNTIME REASON',
    isIcon: true,
  },
  {
    sNo: 4,
    link: '/common/dailyProductionTiles',
    isLink: true,
    clauseNo: 4,
    icon: <TbBuildingWarehouse size="5rem" color="#a12222" />,
    p: 'TESTING',
    span: '',
    // p: 'Daily Production',
    // span: 'Report',
    isIcon: true,
  },
  {
    sNo: 1,
    link: '/common/createEditRevitDailyProductionClone',
    isLink: true,
    clauseNo: 4,
    icon: <HiDocumentReport size="5rem" color="#a12222" />,
    p: 'Daily Production',
    span: 'Report',
    isIcon: true,
  },
  {
    sNo: 5,
    link: '/common/itemMasterVsMachineAndTool',
    isLink: true,
    icon: <GiMachineGun size="5rem" color="#343a40" />,
    p: 'ITEM MASTER VS',
    span: 'MACHINE AND TOOL',
    isIcon: true,
  },
  {
    sNo: 6,
    link: '/common/viewItemMasterList',
    isLink: true,
    icon: <MdOutlineAccessTime size="5rem" color="#343a40" />,
    p: 'PART STROKE',
    span: 'RATE',
    isIcon: true,
  },
  {
    sNo: 6,
    link: '/common/shiftCreationTiles',
    isLink: true,
    icon: <FaDatabase size="5rem" color="#343a40" />,
    p: 'SHIFT & DAY',
    span: 'CREATION',
    isIcon: true,
  },
];
const Clause = () => {
  return (
    <>
      <ChildHeader text="PRODUCTION DEPARTMENT" />
      <RenderTiles tilesObj={tiles} />
    </>
  );
};

export default Clause;
